<template>
<div>
        <!-- About Start -->
        <section class="section" id="about">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-6 order-2 order-md-1 mt-4 pt-2 mt-sm-0 opt-sm-0">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-6 col-6">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <div class="card rounded border-0 shadow overflow-hidden">
                                            <img src="http://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/WechatIMG51.jpeg" class="img-fluid" alt="Image">
                                        </div>
                                    </div><!--end col-->
    
                                    <div class="col-lg-12 col-md-12 mt-4 pt-2">
                                        <div class="card rounded border-0 shadow overflow-hidden">
                                            <img src="http://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/WechatIMG52.jpeg" class="img-fluid" alt="Image">
                                        </div>
                                    </div><!--end col-->
                                </div><!--end row-->
                            </div><!--end col-->

                            <div class="col-lg-6 col-md-6 col-6">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <div class="card rounded border-0 shadow overflow-hidden">
                                            <img src="http://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/WechatIMG53.jpeg" class="img-fluid" alt="Image">
                                        </div>
                                    </div><!--end col-->
    
                                    <div class="col-lg-12 col-md-12 mt-4 pt-2">
                                        <div class="card rounded border-0 shadow overflow-hidden">
                                            <img src="http://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/WechatIMG54.jpeg" class="img-fluid" alt="Image">
                                        </div>
                                    </div><!--end col-->
                                </div><!--end row-->
                            </div><!--end col-->
                        </div><!--end row-->
                    </div><!--end col-->

                    <div class="col-lg-6 col-md-6 col-12 order-1 order-md-2">
                        <div class="section-title ml-lg-5">
                            <h4 class="title mb-4">公司简介</h4>
                            <p class="text-indent text-muted mb-0">爱拼考是上海爱拚氪数字科技有限责任公司自主研发的云原生数字化教育系统，旨在运用人工智能、区块链、云计算、大数据等高端前沿科学技术，为传统考试和学习培训带来颠覆性变革，给用户提供前所未有的增值服务体验。</p>
                          <p class="text-muted text-indent mb-0">  公司团队集结了高等院校、互联网、人力资源、生产制造、金融科技等多个领域的资深业内人士，核心技术团队成员来自腾讯、京东、哔哩哔哩、优刻得等尖端互联网科技公司，拥有丰富的软件开发和运维经验。</p>
                          <p class="text-muted mb-0 text-indent">  爱拼考专注于研究传统培训、考试的痛点和难点，以智能、高效、稳定、安全的在线培训考试系统，为客户定制覆盖整个培训、考试全生命周期的、全方位的技术解决方案，助力用户搭建“学+练+考+评”全生态链服务体系。爱拼考包含课程学习（录播、直播）、练习、考试、互动参与（问卷调查、在线测评、在线投票、360测评、报名表单）等4大类数十个功能模块，同时突破固有思维，创建用户内容变现模式，赋能内容生产，激发用户在细分领域的原创热情，打造可持续发展的商业模式。</p>
                          <p class="text-muted mb-0 text-indent">  截至2021年4月，公司已取得软件著作权12项、注册商标1项，正在申请专利1项、软件著作权6项、商标2项。爱拼考在线培训考试系统顺利通过CMA和CNAS检测认证。产品用户遍及全国各地，广泛分布于教育、金融、房地产、互联网、新零售等垂直行业及政府机关、企事业单位，产品性价比高。</p>


<!--                            <div class="row">-->
<!--                                <div class="col-lg-6 mt-4 pt-2">-->
<!--                                    <div class="media align-items-center rounded shadow p-3">-->
<!--                                        <i data-feather="airplay" class="fea text-primary"></i>-->
<!--                                        <h6 class="ml-3 mb-0"><a href="javascript:void(0)" class="text-dark">责任</a></h6>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-lg-6 mt-4 pt-2">-->
<!--                                    <div class="media align-items-center rounded shadow p-3">-->
<!--                                        <i data-feather="download" class="fea text-primary"></i>-->
<!--                                        <h6 class="ml-3 mb-0"><a href="javascript:void(0)" class="text-dark">服务</a></h6>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-lg-6 mt-4 pt-2">-->
<!--                                    <div class="media align-items-center rounded shadow p-3">-->
<!--                                        <i data-feather="user" class="fea text-primary"></i>-->
<!--                                        <h6 class="ml-3 mb-0"><a href="javascript:void(0)" class="text-dark">支持</a></h6>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-lg-6 mt-4 pt-2">-->
<!--                                    <div class="media align-items-center rounded shadow p-3">-->
<!--                                        <i data-feather="codepen" class="fea text-primary"></i>-->
<!--                                        <h6 class="ml-3 mb-0"><a href="javascript:void(0)" class="text-dark">开发</a></h6>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--&lt;!&ndash;                                <div class="col-12 mt-4 pt-2">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <div class="watch-video">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <a href="javascript:void(0)" class="btn btn-primary mb-2 mr-2">了解更多 <i data-feather="chevron-right" class="fea icon-sm"></i></a>&ndash;&gt;-->
<!--&lt;!&ndash;                                        &lt;!&ndash; <a href="http://vimeo.com/99025203" class="video-play-icon watch title-dark text-dark mb-2"><i class="mdi mdi-play play-icon-circle text-center d-inline-block mr-2 rounded-pill text-white title-dark position-relative play play-iconbar"></i> Watch Now</a> &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                            </div>-->
                        </div>
<!--                      <div class="section-title ml-lg-5" style="margin-top: 40px;">-->
<!--                        <h6 class="text-primary font-weight-normal mb-3"></h6>-->
<!--                        <h4 class="title mb-4">我们的情怀</h4>-->
<!--                        <p class="text-indent text-muted mb-0">作为一家具有高度社会责任意识的企业，成长中的我们仍坚持积极践行公益。</p>-->
<!--                        <p class="text-muted text-indent mb-0"> 我们郑重承诺，包括但不限于：每个季度将一定比例的销售收入，捐向中西部贫 困地区慈善组织或特定群体救助组织，同时中西部贫困地区 K12 学校用户长期 享受优惠价格。</p>-->
<!--                      </div>-->
                    </div><!--end col-->
                </div><!--enr row-->
            </div><!--end container-->


         
            <!-- CTA End -->
        </section><!--end section-->
        <!-- About End -->
</div>
</template>

<script>


export default {
  components: {
  
  }
}
</script>

<style>
.text-indent{text-indent: 2em  }
</style>
